import { Translation } from '../../models/translation';
import { TRANSLATIONS_ACTIONS } from '../actions/translations.actions';

export function translationsReducer(state: Translation[] = [], action) {
  switch (action.type) {

    case TRANSLATIONS_ACTIONS.SET_TRANSLATIONS:
      return Object.assign([], action.payload);

    case TRANSLATIONS_ACTIONS.UPDATE_TRANSLATION:
      state.forEach((translation, index) => {
        if (translation.id === action.payload.id) {
          state[index].picture = action.payload.picture;
        }
      });
      return Object.assign([], state);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/store/reducers/translations.reducer.ts